import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Check, AlertTriangle } from 'lucide-react';
import { onNotice } from './oilNotice';
import { sfxOpen, sfxClose } from './oilSounds';

const SKIN = {
  ok: { border: 'border-amber-500/80', glow: 'rgba(245,158,11,0.45)', ring: 'border-emerald-400/70 bg-emerald-950/60 text-emerald-300', title: 'text-amber-200' },
  fail: { border: 'border-red-700/80', glow: 'rgba(239,68,68,0.4)', ring: 'border-red-500/70 bg-red-950/60 text-red-300', title: 'text-red-200' },
};

export const OilNotice = () => {
  const [queue, setQueue] = useState([]);

  useEffect(() => onNotice((n) => { sfxOpen(); setQueue((q) => [...q, n]); }), []);

  const cur = queue[0];
  if (!cur) return null;
  const s = SKIN[cur.kind] || SKIN.ok;
  const close = () => { sfxClose(); setQueue((q) => q.slice(1)); };
  const Icon = cur.kind === 'fail' ? AlertTriangle : Check;

  return createPortal(
    <div className="fixed inset-0 z-[98] flex items-center justify-center bg-black/85 p-6 backdrop-blur-sm"
      data-testid="oil-notice-overlay" onClick={close}>
      <div onClick={(e) => e.stopPropagation()} data-testid={`oil-notice-${cur.kind}`}
        className={`w-full max-w-[300px] rounded-2xl border-2 ${s.border} bg-gradient-to-b from-[#1a1408] to-[#0a0906] p-6 text-center`}
        style={{ boxShadow: `0 0 40px ${s.glow}`, animation: 'oil-notice-pop 300ms cubic-bezier(.16,1,.3,1)' }}>
        <style>{`@keyframes oil-notice-pop { from { opacity: 0; transform: scale(.75) } to { opacity: 1; transform: scale(1) } }`}</style>
        {cur.icon ? (
          <img src={cur.icon} alt="" className="mx-auto h-16 w-auto" data-testid="oil-notice-icon"
            style={{ filter: `drop-shadow(0 0 16px ${s.glow})` }} />
        ) : (
          <span className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full border-2 ${s.ring}`}>
            <Icon className="h-7 w-7" />
          </span>
        )}
        <p className={`mt-4 text-base font-black leading-snug ${s.title}`} data-testid="oil-notice-title">{cur.title}</p>
        {cur.desc && <p className="mt-2 text-xs leading-relaxed text-zinc-300" data-testid="oil-notice-desc">{cur.desc}</p>}
        <button onClick={close} data-testid="oil-notice-confirm"
          className="mt-5 w-full rounded-full border border-amber-600/70 bg-black/60 py-2 text-[10px] font-black uppercase tracking-widest text-amber-300 transition-transform active:scale-95">
          {cur.kind === 'fail' ? 'Entendi' : 'Beleza'}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default OilNotice;
